<template>
    <v-list-tile>
        <v-dialog v-model="mostrarDialogoSuspender" persistent :max-width="Modal.Processamento.larguraMaxima" @input="tratarEventoAbrirModal">
            <v-list-tile-title slot="activator">
                <i class="fas fa-pause-circle mr-2" aria-hidden="true"/>
                Suspender
            </v-list-tile-title>

            <modal-suspender-compra-direta ref="modalSuspender"
                                           v-model="dadosModal"
                                           :motivo-suspensao="motivoSuspensao"
                                           :anexo-suspensao="anexoSuspensao"
                                           @salvarSuspensao="tratarEventoSuspender"
                                           @fecharModalSuspensao="tratarEventoFecharModal"/>
        </v-dialog>
    </v-list-tile>
</template>

<script>
import {actionTypes, Modal} from '@/core/constants'
import ModalSuspenderCompraDireta from './ModalSuspenderCompraDireta'
import {mapState} from 'vuex'

export default {
    name: 'AcoesSuspender',
    components: {ModalSuspenderCompraDireta},
    props: {
        compraDiretaId: {
            required: true
        }
    },
    data() {
        return {
            mostrarDialogoSuspender: false,
            processando: false,
            dadosModal: {},
            motivoSuspensao: '',
            anexoSuspensao: null,
            Modal
        }
    },
    computed: {
        ...mapState(['resumoCompraDireta'])
    },
    methods: {
        async tratarEventoAbrirModal(isOpen) {
            if (isOpen) {
                try {
                    await this.$store.dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, this.compraDiretaId)
                    
                    if (this.resumoCompraDireta) {
                        this.motivoSuspensao = this.resumoCompraDireta.justificativaSuspensao || ''
                        this.anexoSuspensao = this.resumoCompraDireta.anexoSuspensao || null
                    }
                } catch (error) {
                    this.mostrarNotificacaoErro('Erro ao buscar dados da compra direta.')
                }
            }
        },

        async tratarEventoSuspender(objModal) {
            this.processando = true
            
            try {
                const objParaSuspender = {
                    compraDiretaId: this.compraDiretaId,
                    dados: {
                        justificativaSuspensao: objModal.motivo,
                        nomeArquivo: null,
                        uri: null,
                    }
                }

                if (objModal.arquivo) {
                    objParaSuspender.dados.nomeArquivo = objModal.arquivo.nome
                    objParaSuspender.dados.uri = await this.uploadArquivo(objModal.arquivo.file)
                }

                await this.$store.dispatch(actionTypes.SUSPENDER_COMPRA_DIRETA, objParaSuspender)
                
                this.mostrarNotificacaoSucesso('Compra direta suspensa com sucesso.')
                if (this.$refs.modalSuspender && this.$refs.modalSuspender.limparFormularioAposSalvar) {
                    this.$refs.modalSuspender.limparFormularioAposSalvar()
                }
                this.tratarEventoFecharModal()
                this.$emit('compraDiretaSuspensa')

            } catch (error) {
                this.mostrarNotificacaoErro(error.message || 'Erro ao suspender compra direta.')
            } finally {
                this.processando = false
            }
        },

        async uploadArquivo(arquivo) {
            if (!arquivo) return null
            
            const formData = new FormData()
            formData.append('file', arquivo)
            
            const { arquivo: uploadedFile } = await this.$store.dispatch(actionTypes.UPLOAD_ARQUIVO_SEM_LOKI, formData)
            
            return uploadedFile.uri
        },

        tratarEventoFecharModal() {
            this.mostrarDialogoSuspender = false
            this.dadosModal = {}
            this.processando = false
        }
    }
}
</script>

<style scoped>
.v-dialog__container {
    width: 100%;
}

.acoes {
    padding: 16px 24px;
}
</style>